Drupal.behaviors.literature_references = {
  attach(context) {
    context.querySelectorAll('.prose sup').forEach((sup) => {
      sup.setAttribute('onclick', `window.location='#lit-ref-${sup.innerText}'`);
    });
  },
};
